
import { useState } from "react";
import { GroupLeaderRequest } from "@/types/admin-requests";

/**
 * Hook to manage the state for admin requests
 */
export const useRequestState = () => {
  const [requests, setRequests] = useState<GroupLeaderRequest[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [processingId, setProcessingId] = useState<string | null>(null);

  return {
    requests,
    setRequests,
    isLoading,
    setIsLoading,
    processingId,
    setProcessingId,
  };
};
